// Guards against open-redirect and javascript:/data: URI XSS when navigating via window.location.
// Used for Client_DOM_XSS and Client_DOM_OpenRedirect vulnerabilities.
export const isSafeRelativeUrl = (url: string): boolean => {
    if (!url || typeof url !== "string") return false;
    if (!url.startsWith("/") || url.startsWith("//") || url.startsWith("/\\")) return false;
    if (/^\s*[a-z][a-z0-9+.-]*:/i.test(url)) return false;
    return true;
};
